import * as Hooks from '../hooks'
import Description from './Description'
import ErrorMessage from './ErrorMessage'

export default function Fieldset({ legend, description, children, widget, className, ...props }) {
    const { name } = props
    const Widget = Hooks.useWidget(widget?.name)

    if (Widget) {
        children = (
            <Widget props={props} options={widget.options}>
                {children}
            </Widget>
        )
    }

    return (
        <fieldset className={className}>
            {legend && <legend>{legend}</legend>}
            <Description>{description}</Description>
            <ErrorMessage name={name} />
            {children}
        </fieldset>
    )
}
